import { oc } from '@orpc/contract';
import { createKpiInputSchema, kpiSchema } from '../schemas/kpis.schemas.js';
export const createKpiContract = oc
    .route({
    method: 'POST',
    path: '/kpis',
    tags: ['KPIs'],
    summary: 'Create a manual or calculated KPI; 409 with structured formula warnings unless confirmWarnings (ADMIN, PM)',
})
    .input(createKpiInputSchema)
    .output(kpiSchema);
//# sourceMappingURL=create-kpi.contract.js.map